import { AfterViewInit, Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './shared/service/auth-service/auth-service.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Art57Section } from './shared/ui/Art57Section/Art57Section';
import { TreeNodeXEVPRMImportedMessage } from './shared/ui/Node/WebTraderNode/Entity/TreeNodeXEVPRMImportedMessage';
import { InactivityService } from './shared/service/inactivity-service/inactivity.service';
import { LoggerService } from './shared/service/logger-service/logger.service';
import { MaintenanceService } from './shared/service/maintenance-service/maintenance.service';
import { Util } from './shared/ui/Util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  private readonly _destroying$ = new Subject<void>();

  isMaintenance!: Observable<boolean>;
  maintenanceType!: Observable<String>;

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    private injector: Injector,
    private inactivityService: InactivityService,
    private msalService: MsalService,
    private loggerService: LoggerService,
    private maintenanceService: MaintenanceService
  ) { }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  ngAfterViewInit(): void {
    if (this.authService.getPrincipal() != null) {
      Util.markAppAsReady();
    }
  }

  ngOnInit() {
    this.isMaintenance = this.maintenanceService.isMaintenance$;
    this.maintenanceType = this.maintenanceService.maintenanceType$;

    this.msalService.instance
      .handleRedirectPromise()
      .then((authResult) => { })
      .catch((error) => {
        this.loggerService.warn('MSAL not initialized. Requesting to reinitialize MSAL. (AppComponent.ngOnInit())');
        this.msalService.initialize().subscribe({
          next: () => {
            this.loggerService.debug('MSAL initialization completed successfully. (AppComponent.ngOnInit())');
          },
          error: (initError) => {
            this.loggerService.err('MSAL initialization failed. (AppComponent.ngOnInit())', initError);
          }
        });
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        this.loggerService.debug('Requesting to acquire and store Access token. (AppComponent.ngOnInit()');
        this.authService.acquireAndStoreAccessToken();
      });

    //!!!! 
    // Do not move this function to organisation-selector.component.ts otherwise you will lose the monitoring in scenario:
    // 1. Pass 2nd step of login
    // 2. Work as usualy or do nothing
    // 3. Refresh the page (for this reason it must be here, you can test it ;) )
    //!!!!
    this.initializeInactivityMonitoring();
  }

  private initializeInactivityMonitoring(): void {
    this.inactivityService.getInactivityObservable().subscribe((isInactive) => {
      if (isInactive) {
        this.onLogOut();
      }
    });
    this.inactivityService.startMonitoring();
  }

  onLogOut() {
    this.authService.logOut();
  }

  onMessageClick(message: any) {

    if (message.node instanceof TreeNodeXEVPRMImportedMessage) {
      this.injector.get(Art57Section).displayErrors(message.node);
    }

  }

  getIcon(severity: string): string {
    switch (severity) {
      case 'success':
        return 'check-circle';
      case 'info':
        return 'info-circle';
      case 'warn':
        return 'exclamation-triangle';
      case 'error':
        return 'times-circle';
      default:
        return 'info-circle';
    }
  }

}
